import { EmployeeBenefit } from './benefit.model';
import { SerializableBulkSelection } from '@table/types/bulk-selection.type';

export class EmployeeBenefitBulk extends EmployeeBenefit {
    protected static _resource = 'payroll/companies/:company/benefits/:benefit/bulk';

    protected static _serializeAttributes = [
        'premiumAmount',
        'premiumCalculatorType',
        'contributionAmount',
        'contributionCalculatorType',
        'benefitDeductionFrequencyId',
        'effectiveDate',
        'bulkSelection',
    ];

    get bulkSelection(): SerializableBulkSelection {
        return this._attributes['bulkSelection'];
    }

    set bulkSelection(val: SerializableBulkSelection) {
        this._attributes['bulkSelection'] = val;
    }
}
